import { ServiceManager, ServiceBusController, ServiceBusControllerBody } from '@estee/elc-service';
import { events, on, queryProvider, serviceQueries } from '@estee/elc-service-bus';

const queries = [[serviceQueries.GET_BEST_MATCH_SKU_ID, 'getBestMatchSkuId']];

export class ServiceBus extends ServiceBusController {
    @on(events.ECOMM_STARTED, { replay: true })
    public onEcommStarted = () => {
        const id = setInterval(() => {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (serviceBusBaseClass) {
                clearInterval(id);
                queries.forEach(ServiceManager.setDecoratorOnFunction(queryProvider));
            }
        }, 50);
    };
}

export const serviceBusBaseClass = new ServiceBus() as ServiceBusController &
    ServiceBusControllerBody;
